























import Vue from 'vue'
import DocumentationsForm from '@/UI/Auction/Documentations/DocumentationsForm.vue'
import DocumentationsFormTitle from '@/UI/Auction/Documentations/DocumentationsFormTitle.vue'
import UserTypeSelector from '@/UI/Auction/Documentations/UserTypeSelector.vue'
import { DocumentationsData } from '@/Infrastructure/Store/Auction/DocumentationsData'

const userTipologies: { [key: number]: number [] } = {
  0: [],
  1: [1, 2, 3, 4],
  2: [5, 6, 1, 2, 3, 4],
  3: [1, 2, 3, 4],
  4: [7, 8, 1, 2, 4]
}

export default Vue.extend({
  name: 'DocumentationsLayout',
  components: {
    DocumentationsForm,
    DocumentationsFormTitle,
    UserTypeSelector
  },
  props: {
    userType: {
      type: Number,
      default: 0
    },
    documentation: {
      type: Array as () => DocumentationsData[],
      required: true
    },
    procedureId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      currentUserType: 0,
      currentDocumentation: [] as DocumentationsData[]
    }
  },
  computed: {
    selectedUserType (): number[] {
      return userTipologies[this.userType]
    }
  },
  watch: {
    userType (newValue: number, oldValue: number) {
      if (newValue !== oldValue) {
        this.currentUserType = newValue
      }
    },
    documentation (newValue: DocumentationsData[], oldValue: DocumentationsData[]) {
      if (newValue !== oldValue) {
        this.currentDocumentation = newValue
      }
    }
  },
  created () {
    this.currentUserType = this.userType
    this.currentDocumentation = this.documentation
  },
  methods: {
    onUserTypeChanged ($event: number) {
      this.$emit(
        'usertype-changed',
        { userType: $event, documentationNeeded: userTipologies[$event] }
      )
    },
    onDocumentationUpdated ($event: DocumentationsData) {
      const updatedDocumentation = this.currentDocumentation.filter(current => current.idItem !== $event.idItem)
      if (this.isValidDocumentationData($event)) {
        updatedDocumentation.push($event)
      }
      this.$emit('documentation-updated', updatedDocumentation)
    },
    isValidDocumentationData (documentationData: DocumentationsData): boolean {
      if (documentationData.file) {
        return true
      }
      const hasProcedureData = documentationData.codProcedemento !== '' &&
        documentationData.organo !== '' &&
        documentationData.ano !== ''
      return hasProcedureData
    }
  }
})
